// src/App.jsx
import React from "react";
import { useEffect, useState } from "react";
import img1 from "../Assets/1.png"

function Internship() {
    
    return (
        <div className="min-h-screen max-w-2xl text-black p-4 font-serif">
        {/* Name */}
        <p className="text-3xl mb-2">
        We are looking for meritorious students :
        </p>

        {/* Email */}
        <p className="text-lg mb-2 mt-4">
        Eligibility :
        </p>
        <p className="f text-lg mb-2">
        {">> B.Tech / M.Tech / M. S / Others, from the reputed institutes"}
        </p><p className="text-lg mb-2">
        {">> Internship duration: Minimum 3 months and More"}
        </p><p className="text-lg mb-2">
        Contact:
        </p><p className="font-bold text-lg mb-2 mt-4">
        Prof. Navin Kumar
        </p><p className=" text-lg mb-2">
        (Head of Department (HOD), Mechanical Engineering)
        </p><p className=" text-lg mb-2">
        E-Mail- nkumar@iitrpr.ac.in
        </p>

    </div>
    );
}

export default Internship;